export const demoValidation = {
  demoDate: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isSkipped: {
          eq: false,
        },
      },
    },
  },
  details: {
    type: 'string',
    required: {
      value: true,
      when: {
        $demoRecordLink: {
          eq: undefined,
        },
        $isSkipped: {
          eq: false,
        },
      },
    },
  },
  demoRecordLink: {
    type: 'string',
    required: {
      value: true,
      when: {
        $details: {
          eq: undefined,
        },
        $isSkipped: {
          eq: false,
        },
      },
    },
    link: true,
  },
  isSkipped: {
    type: 'boolean',
    required: false,
  },
  skipReason: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isSkipped: {
          eq: true,
        },
      },
    },
  },
};
